<template>
  <v-app>
    <v-container>
      <v-card>
        <v-card-title>
          Create Member
          <v-spacer></v-spacer>
          <v-btn text icon to="/members">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>
      <v-card>
        <v-form>
          <v-flex xs8 offset-xs2>
            <v-text-field
              label="Member ID"
              name="memberid"
              id="memberid"
              v-model="memberid"
              :rules="rule1"
            >
            </v-text-field>
            <v-text-field
              label="Role"
              name="role"
              id="role"
              v-model="role"
              :rules="rule1"
            >
            </v-text-field>
            <v-text-field
              label="Full Name"
              name="name"
              id="name"
              v-model="name"
              :rules="rule1"
            >
            </v-text-field>
            <v-select
              :items="items"
              label="Gender"
              name="gender"
              id="gender"
              v-model="gender"
              :rules="rule1"
            >
            </v-select>
            <v-text-field
              label="Work Location"
              name="location"
              id="location"
              v-model="location"
              :rules="rule2"
            >
            </v-text-field>
            <v-text-field
              label="Email Address"
              name="email"
              id="email"
              v-model="email"
              :rules="rule2"
            >
            </v-text-field>
            <v-text-field
              label="Contact Number"
              name="contact"
              id="contact"
              v-model="contact"
              :rules="rule1"
            >
            </v-text-field>
          </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!formIsValid"
            class="ma-2"
            color="green"
            @click="onCreateMember"
          >
            <v-icon left>mdi-plus</v-icon>
            Add Member
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  title: 'Create Member',
  data () {
    return {
      items: ['M', 'F'],
      rule1: [
        value => !!value || 'Required',
        value => (value || '').length <= 40 || 'Max 40 characters'
      ],
      rule2: [
        value => !!value || 'Required',
        value => (value || '').length <= 100 || 'Max 100 characters'
      ],
      memberid: '',
      role: '',
      name: '',
      gender: '',
      location: '',
      email: '',
      contact: ''
    }
  },
  methods: {
    onCreateMember () {
      if (!this.formIsValid) {
        return
      }
      const memberData = {
        memberid: this.memberid,
        role: this.role,
        name: this.name,
        gender: this.gender,
        location: this.location,
        email: this.email,
        contact: this.contact
      }
      this.$store.dispatch('createMember', memberData)
      this.$router.push('/members')
    }
  },
  computed: {
    formIsValid () {
      return this.memberid !== '' &&
      this.name !== '' &&
      this.gender !== '' &&
      this.role !== '' &&
      this.location !== '' &&
      this.email !== '' &&
      this.contact !== ''
    }
  }
}
</script>
